import React, { Fragment, useState, useEffect } from "react";
import _ from "lodash";
import useHttp from "./hooks/useHttp";
import TitlesSlider from "./containers/title-slider/title-slider";
import ContentSlider from "./containers/drawer/drawer";
import OpenCloseButton from "./components/drawer-toggle-button/drawer-toggle-button";
import SidebarWrapper from "./containers/sidebar/sidebar";
import useWindowSize from "./hooks/useWindowSize";
import useCookies from "./hooks/useCookies";
import usePageIdentifier from "./hooks/usePageIdentifier";
import DrawerContentWrapper from "./layout/drawerContentLayout";
import apiURL from "./config/api";
import { getTaggingFunc } from './helpers/dataLayerData';
import "./App.css";

function App() {
  const defaultBgColor = "#1966af";
  const [drawerBgColor, setDrawerBgColor] = useState();
  const [contentSliderDataArr, setContentSliderDataArr] = useState();
  const [drawerType, setDrawerType] = useState()
  const [drawerSessionType, setDrawerSessionType] = useState()
  const [drawerDefaultLoading, setDrawerDefaultLoading] = useState()
  const [drawerSessionTimeoutValue, setDrawerSessionTimeoutValue] = useState()
  const [PageVisibilityValidation, setPageVisibilityValidation] = useState()
  const [titleSliderDataArr, setTitleSliderDataArr] = useState();
  const [validDateToDiplay, setValidDateToDiplay] = useState(false);
  const [interactionInterval, setInteractionInterval] = useState(true);
  const [defaultInterval, setDefaultInterval] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [userToggled, setUserToggled] = useState()
  const [sideDrawerTitle, setSideDrawerTitle] = useState()
  const [collapsedDrawerTextColor, setCollapsedDrawerTextColor] = useState('#fff')
  const [timeoutFunc, setTimeoutFunc] = useState()
  const { pageTitle } = usePageIdentifier();
  const { error, sendRequest: fetchTasks } = useHttp();
  const screenStatus = useWindowSize();
  const {
    setContentDrawerInteractionCookie,
    setContentDrawerTimeoutCookie,
    cookiesValidation,
    cookiesIntractionValidation,
  } = useCookies();
  //console.log("pageTypeIdentifier: ", pageTypeIdentifier);
  const toggleDrawer = (x, y) => {
    setUserToggled('Clicked')
    //console.log(userToggled)
    if(!((y === 'static' || y === '') && x === '')){
      setContentDrawerInteractionCookie();
    }
    // }else{
    //   console.log('PERMANENT')
    // }
 
    setShowDrawer(!showDrawer);
    let drawerStatus = null
    showDrawer === false ? drawerStatus = 'Open': drawerStatus = 'Close'
    //console.log('Drawer Status: ', drawerStatus, screenStatus)
    getTaggingFunc(screenStatus , drawerStatus, `${drawerStatus} Drawer`,`${screenStatus === 'mobile' ? 'Bottom' : ''}`)
  };

  const setDefaultIntervalFunc = () => {
    setDefaultInterval(true);
    //console.log('intraction true')
  };

  let firbaseUrl = null;
  firbaseUrl = apiURL.url + `${pageTitle}.json`;
  //console.log(firbaseUrl)

  const dataValidator = (Obj) => {
    //console.log("transformeddataValidator: ", Obj);

    const drawerSessionTypeIndex = Obj.Session_Type.toLowerCase()
    setDrawerSessionType(drawerSessionTypeIndex)
    //console.log("drawerSessionTypeIndex: ", drawerSessionTypeIndex)
 
    const drawerSessionTimeOutIndex = Obj.Session_Timeout_Min
    setDrawerSessionTimeoutValue(drawerSessionTimeOutIndex)
    //console.log("drawerSessionTimeOutIndex: ", drawerSessionTimeOutIndex) 
    //console.log(Obj.Drawer_Type)
    const textOfDrawerType = Obj.Drawer_Type.toLowerCase()
    setDrawerType(textOfDrawerType)

    //timeout function
    const timeOutSession =  ( timeout, sessionType) => {
      //console.log(timeout)
      let timeoutValue  
      let interval
      //console.log(timeout, sessionType)
      //senario.1 (type = session OR static OR '') & (timeout = number) ==> CookieTimeout = number
      if(timeout !== undefined && timeout !== '' && timeout !== 0 && typeof(timeout) === 'number' && ((sessionType === 'session' || sessionType === 'static') || (sessionType === '' && sessionType === ''))){
        timeoutValue = timeout * 60 * 1000
        //console.log(timeoutValue)
         setTimeout(() => {
          //let interval
          //console.log(timeoutValue)
          //setInteractionInterval(false);
          interval = false
          setInteractionInterval(interval)
        }, timeoutValue);
      //senario.2 (type = static OR '') & (timeout = '') ==> CookieTimeout = permanently
      }else if((timeout === undefined || timeout === '' || timeout === 0 || typeof(timeout) !== 'number') &&  (sessionType === 'static' || sessionType === '')){
        //console.log('Static is activated!')
        setInteractionInterval(true)
      }else{
        //console.log('default session is activated!')
        timeoutValue = 600000
         setTimeout(() => {
          //let interval
          //console.log(timeoutValue)
          //setInteractionInterval(false);
          interval = false
          setInteractionInterval(interval)
        }, timeoutValue);
      }
    }

    //console.log(drawerSessionTimeOutIndex, drawerSessionTypeIndex)
    // trigger timeout function
    timeOutSession (drawerSessionTimeOutIndex, drawerSessionTypeIndex)

    let drawerLoadingStatus = Obj.Drawer_Load_State.toLowerCase()
    const drawerLoadStateCloseDelay = Obj.Drawer_Load_State_Close_Delay
    const drawerLoadStateOpenDelay = Obj.Drawer_Load_State_Open_Delay
    //console.log('Obj.Drawer_Load_State_Close_Delay: ', Obj.Drawer_Load_State_Close_Delay)
    //console.log('Obj.Drawer_Load_State_Open_Delay: ', Obj.Drawer_Load_State_Open_Delay === '')
    if(drawerLoadingStatus === ''){
      drawerLoadingStatus = 'open'
      setDrawerDefaultLoading('open')
    }else{
      setDrawerDefaultLoading(drawerLoadingStatus)
    }

    if(drawerLoadingStatus === 'open' &&  screenStatus !== "mobile") { 
      //console.log('Drawer status: ', drawerLoadingStatus )
      setShowDrawer(!showDrawer)
      if(drawerLoadStateCloseDelay !== ''  && userToggled !== 'Clicked'){ // close open-drawer by delay dynamically
        //console.log(userToggled)
        //console.log('drawerLoadStateCloseDelay: ', drawerLoadStateCloseDelay)
        setTimeoutFunc(setTimeout(() => {
          setShowDrawer(showDrawer)
        }, drawerLoadStateCloseDelay * 1000))
        if(drawerLoadStateOpenDelay !== ''){
          setTimeoutFunc(setTimeout(() => {
            setShowDrawer(!showDrawer)
          }, (drawerLoadStateOpenDelay + drawerLoadStateCloseDelay) * 1000))  
        }
      }else if(userToggled === 'Clicked'){ // if user has any intractions before timeout time ended
        setShowDrawer(showDrawer)
        //console.log(timeoutFunc)
        clearTimeout(timeoutFunc)
        setTimeoutFunc(null)
        //console.log("else if(userToggled 1 === 'Clicked'")
      }
  }  //: setShowDrawer(showDrawer)
    
    if(drawerLoadingStatus === 'closed' &&  screenStatus !== "mobile") { 
      //console.log('Drawer status: ', drawerLoadingStatus )
      setShowDrawer(showDrawer)
      if(drawerLoadStateOpenDelay !== '' && userToggled !== 'Clicked'){ // open close-drawer by delay dynamically
        //console.log(userToggled)
        //console.log('drawerLoadStateOpenDelay: ', drawerLoadStateOpenDelay)
        setTimeoutFunc(setTimeout(() => {
          setShowDrawer(!showDrawer)
        }, drawerLoadStateOpenDelay * 1000))
        if(drawerLoadStateCloseDelay !== ''){
          setTimeoutFunc(setTimeout(() => {
            setShowDrawer(showDrawer)
          }, (drawerLoadStateCloseDelay + drawerLoadStateOpenDelay) * 1000))
        }
        //clearTimeout(timer2)
        //console.log(timer2)
      }else if(userToggled === 'Clicked'){ // if user has any intractions before timeout time ended
        //console.log(timeoutFunc)
        clearTimeout(timeoutFunc)
        setTimeoutFunc(null)
        //console.log("else if(userToggled 2 === 'Clicked'")
      }
  }


    //console.log('drawerLoadingStatus: ', drawerLoadingStatus)

    const collapsedDrawerTextColorIdentify = Obj.Drawer_Text_Colour
    setCollapsedDrawerTextColor(collapsedDrawerTextColorIdentify)
    //console.log('collapsedDrawerTextColorIdentify: ', collapsedDrawerTextColorIdentify)

    let startDate;
    let endDate;
    const currentDate = new Date();
    let pageVisibility = false 
    //console.log('Obj.Page_Title: ', Obj.Page_Title , typeof(Obj.Page_Title), Obj.Page_Title.length)
    //console.log('Obj.Page_URL: ', Obj.Page_URL , typeof(Obj.Page_URL), Obj.Page_URL.length)
    Obj.Page_URL.length === 0 ? pageVisibility = false :  pageVisibility = true 
    //console.log('Page Validation: ',pageVisibility)
    //console.log(Obj.Drawer_TimingUp)
    setPageVisibilityValidation(pageVisibility)
    Obj.Drawer_TimingUp === ""
      ? (startDate = currentDate)
      : (startDate = new Date(Obj.Drawer_TimingUp));
    Obj.Drawer_TimingDown === ""
      ? (endDate = new Date("2/20/2026"))
      : (endDate = new Date(Obj.Drawer_TimingDown));
    const dateValidtion = currentDate <= endDate && currentDate >= startDate;
    setValidDateToDiplay(dateValidtion);
    //console.log("dateValidtion: ", dateValidtion);
    //setDrawerData(Obj);
    const drawerBgColorItem = Obj.Drawer_bdColour;
    //console.log(drawerBgColorItem)
    setDrawerBgColor(drawerBgColorItem);
    const sideDrawerButtomTitle = Obj.SideDrawer_title;
    //console.log('sideDrawerButtomTitle: ',sideDrawerButtomTitle)
    setSideDrawerTitle(sideDrawerButtomTitle)
    setDrawerBgColor(drawerBgColorItem);
    const contentSliderData = _.pickBy(Obj, (value, key) =>
      key.startsWith("Slide_")
    );
    const contentSliderDataArr = _.values(contentSliderData);
    //console.log(contentSliderDataArr);  const contentSliderDataArr = props.contentSliderDataArr
    //console.log(contentSliderDataArr)
    _.remove(contentSliderDataArr, function (e) {
      //let imageUrlValidatorStatus = _.contains(e.images, imageUrlValidator)
      //console.log(e)
      return (e.imageUrl === "" && e.mobileImageUrl === "") || e.redirectURL === "" || e.id === "" ;
    });
    //console.log(contentSliderDataArr);
    setContentSliderDataArr(contentSliderDataArr);
    const titleSliderModel = {
      id: null,
      longDescription: null,
    };
    let titleSliderData = [];
    contentSliderDataArr.map((sliderItem) => {
      var result = _.pick(sliderItem, _.keys(titleSliderModel));
      //console.log('result', result)
      result.longDescription !== "" ? titleSliderData.push(result) : titleSliderData.push() ;
      return result
    });
    setTitleSliderDataArr(titleSliderData);
  };

  useEffect(() => {
    //console.log('userToggled: ', userToggled)
    if (!cookiesIntractionValidation) {
      fetchTasks({ url: firbaseUrl }, dataValidator);
    }
  }, [fetchTasks, userToggled]);

  // Drawer remove condition based on timeout cookie - without intraction
 //console.log(drawerSessionTimeOutIndex && textOfDrawerType)
  
  // Validation for display widget
  const widgetDisplayCondition =
    PageVisibilityValidation &&
    !cookiesValidation &&
    !error &&
    contentSliderDataArr &&
    contentSliderDataArr.length > 1 &&
    validDateToDiplay &&
    (interactionInterval || defaultInterval);
  // Validation for set cookie (*if data can't pass validation to display React shouldn't set Cookie)
  const cookieSetCondition =
    PageVisibilityValidation &&
    !cookiesValidation &&
    !error &&
    contentSliderDataArr &&
    contentSliderDataArr.length > 1 &&
    validDateToDiplay &&
    !interactionInterval &&
    !defaultInterval;

  if (cookieSetCondition) {
    setContentDrawerTimeoutCookie();
    //console.log("content-drawer-timeout is set"); //
  }
  //console.log(drawerType)
  return (
    <Fragment>
      {widgetDisplayCondition ? (
        drawerType && (drawerType === "side" || drawerType === "landscapeside")  && screenStatus === "mobile" ? (
          <SidebarWrapper
            setDefaultIntervalFunc={setDefaultIntervalFunc}
            contentSliderDataArr={contentSliderDataArr}
            drawerBgColor={drawerBgColor}
            defaultBgColor={defaultBgColor}
            //screenStatus={screenStatus}
            sideDrawerTitle={sideDrawerTitle}
            drawerDefaultLoading ={drawerDefaultLoading}
            collapsedDrawerTextColor={collapsedDrawerTextColor}
            drawerSessionTimeoutValue ={drawerSessionTimeoutValue}
            drawerSessionType={drawerSessionType}
          />
        ) : (
          <div
            className="drawerWrapper text-white pos-relative"
             style={{
               borderTop:  `10px solid ${
                 drawerBgColor !== "" ? drawerBgColor : defaultBgColor
               }`,
             }}
            onClick={() => {
              setDefaultIntervalFunc();
            }}
          >
            <OpenCloseButton
              toggleDrawer={toggleDrawer}
              setDefaultIntervalFunc={setDefaultIntervalFunc}
              showDrawer={showDrawer}
              drawerBgColor={drawerBgColor}
              defaultBgColor={defaultBgColor}
              collapsedDrawerTextColor={collapsedDrawerTextColor}
              drawerSessionTimeoutValue ={drawerSessionTimeoutValue}
              drawerSessionType={drawerSessionType}
            />

            {!showDrawer ? (
              <div
                onClick={()=>toggleDrawer(drawerSessionTimeoutValue, drawerSessionType)}
                style={{
                  backgroundColor:  `${
                    drawerBgColor !== "" ? drawerBgColor : defaultBgColor
                  }`,
                  marginTop: '-10px'
                }}
              >
                <TitlesSlider 
                  titleSliderDataArr={titleSliderDataArr} 
                  collapsedDrawerTextColor={collapsedDrawerTextColor}
                />
              </div>
            ) : null}
            {showDrawer ? (
              <DrawerContentWrapper
                elClass={`drawerContentWrapper ${screenStatus === 'desktop' ? 'container':''}`}
                drawerBgColor={drawerBgColor}
                defaultBgColor={defaultBgColor}
                //screenStatus={screenStatus}
                drawerType={drawerType}
              >
                <ContentSlider
                  contentSliderDataArr={contentSliderDataArr}
                  drawerType={drawerType}
                />
              </DrawerContentWrapper>
            ) : null}
          </div>
        )
      ) : null}
    </Fragment>
  );
}

export default React.memo(App);
